<div class="layout" [class.layout--nav-open]="sidebarOpen()">

  <!-- Sidebar (altura total da tela) -->
  <nav id="main-navigation" class="layout__nav" aria-label="Navegação principal">
    <div class="layout__nav-brand">
      <img src="assets/images/logo.png" alt="Liessin" class="layout__nav-logo" />
      <button type="button" class="layout__nav-close" (click)="closeSidebar()" aria-label="Fechar menu">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>

    <div class="layout__group">
      <span class="layout__group-label">Geral</span>
      @if (canAccess('/')) {
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="layout__link">
        <i class="bi bi-house"></i> Painel
      </a>
      }
      @if (canAccess('/requirements/new')) {
      <a routerLink="/requirements/new" routerLinkActive="active" class="layout__link">
        <i class="bi bi-file-earmark-plus"></i> Preencher Requerimento
      </a>
      }
    </div>

    <div class="layout__group">
      <span class="layout__group-label">Operacional</span>
      @if (canAccess('/requirements')) {
      <a routerLink="/requirements" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        class="layout__link">
        <i class="bi bi-file-text"></i> Requerimentos Ativos
      </a>
      }
      @if (canAccess('/requirements/trashed')) {
      <a routerLink="/requirements/trashed" routerLinkActive="active" class="layout__link">
        <i class="bi bi-archive"></i> Histórico de Requerimentos
      </a>
      }
      @if (canAccess('/users')) {
      <a routerLink="/users" routerLinkActive="active" class="layout__link">
        <i class="bi bi-people"></i> Usuários
      </a>
      }
    </div>

    <div class="layout__group" [hidden]="auth.isApplicant()">
      <span class="layout__group-label">Configuração</span>
      @if (canAccess('/config-scholarships')) {
      <a routerLink="/config-scholarships" routerLinkActive="active" class="layout__link">
        <i class="bi bi-gear"></i> Configuração de Bolsas
      </a>
      }
      @if (canAccess('/reports')) {
      <a routerLink="/reports" routerLinkActive="active" class="layout__link">
        <i class="bi bi-bar-chart"></i> Relatórios
      </a>
      }
      @if (canAccess('/groups')) {
      <a routerLink="/groups" routerLinkActive="active" class="layout__link">
        <i class="bi bi-shield-lock"></i> Grupos (Perfis)
      </a>
      }
      @if (canAccess('/permissions')) {
      <a routerLink="/permissions" routerLinkActive="active" class="layout__link">
        <i class="bi bi-key"></i> Permissões
      </a>
      }
      @if (canAccess('/civil-statuses')) {
      <a routerLink="/civil-statuses" routerLinkActive="active" class="layout__link">
        <i class="bi bi-person-badge"></i> Estado Civil
      </a>
      }
      @if (canAccess('/property-types')) {
      <a routerLink="/property-types" routerLinkActive="active" class="layout__link">
        <i class="bi bi-building"></i> Tipo de Propriedade
      </a>
      }
      @if (canAccess('/document-types')) {
      <a routerLink="/document-types" routerLinkActive="active" class="layout__link">
        <i class="bi bi-file-earmark-text"></i> Tipo de Documento
      </a>
      }
      @if (canAccess('/institutions')) {
      <a routerLink="/institutions" routerLinkActive="active" class="layout__link">
        <i class="bi bi-bank"></i> Instituição
      </a>
      }
      @if (canAccess('/units')) {
      <a routerLink="/units" routerLinkActive="active" class="layout__link">
        <i class="bi bi-geo-alt"></i> Unidade
      </a>
      }
      @if (canAccess('/education-levels')) {
      <a routerLink="/education-levels" routerLinkActive="active" class="layout__link">
        <i class="bi bi-mortarboard"></i> Nível Escolaridade
      </a>
      }
      @if (canAccess('/settings')) {
      <a routerLink="/settings" routerLinkActive="active" class="layout__link">
        <i class="bi bi-sliders"></i> Configurações do Sistema
      </a>
      }
    </div>
  </nav>

  <!-- Coluna direita: header + conteúdo -->
  <div class="layout__body">
    <app-header [sidebarOpen]="sidebarOpen()" (toggleSidebar)="toggleSidebar()" />
    <main class="layout__main">
      <router-outlet></router-outlet>
    </main>
  </div>

  @if (sidebarOpen()) {
    <div class="layout__backdrop" (click)="closeSidebar()"></div>
  }
</div>
